import React from 'react';
import { Outlet } from 'react-router-dom';
import { Box, CssBaseline, Typography } from '@mui/material';
import Header from './Header';
import Footer from './Footer';
import CookieBanner from '../common/CookieBanner';
import { useTranslation } from 'react-i18next';

const Layout = () => {
  const { t } = useTranslation();

  return (
    <Box sx={{ display: 'flex', minHeight: '100vh' }}>
      <CssBaseline />

      <Header />

      <Box
        component="main"
        sx={{
          flexGrow: 1,
          display: 'flex',
          flexDirection: 'column',
          pt: { xs: '86px', sm: '86px', md: '94px' },
          width: '100%',
          ml: 0
        }}
      >
        {/* Banner rotante sotto navbar */}
        <Box sx={{ bgcolor: '#951520', overflow: 'hidden', py: '3px', width: '100%' }}>
          <Box
            sx={{
              display: 'flex',
              whiteSpace: 'nowrap',
              animation: 'marquee 35s linear infinite',
              '@keyframes marquee': {
                '0%': { transform: 'translateX(100vw)' },
                '100%': { transform: 'translateX(-100%)' },
              },
            }}
          >
            {[...Array(20)].map((_, i) => (
              <Typography
                key={i}
                variant="body2"
                sx={{ color: 'white', fontWeight: 'bold', mx: { xs: 4, sm: 8 }, fontSize: { xs: '0.8rem', sm: '0.9rem' }, letterSpacing: 0.5 }}
              >
                {t('home.banner')}
              </Typography>
            ))}
          </Box>
        </Box>

        <Box sx={{ px: { xs: 2, sm: 4, md: 6 }, flexGrow: 1, display: 'flex', flexDirection: 'column' }}>
          <Outlet />
          <Footer />
        </Box>
      </Box>
      <CookieBanner />
    </Box>
  );
};

export default Layout;
